<template>
  <pp-container
    fluid
    pa-5
  >
    <pp-row>
      <pp-col
        v-if="!callMissed"
        cols="12"
        class="d-flex align-center"
      >
        <i
          class="green white--text pp-icon-check rounded-circle pa-3"
        />
        <h2 class="pl-5">
          Call Ended
        </h2>
      </pp-col>
    </pp-row>
    <pp-row>
      <pp-col cols="12">
        <p>{{ thankYouMessage }}</p>
      </pp-col>
    </pp-row>
    <pp-row>
      <pp-col
        cols="12"
        class="text-center end-call-img"
      >
        <img
          src="@/assets/images/call_ended.png"
          alt="Virtual call ended image"
        >
      </pp-col>
    </pp-row>
    <pp-row>
      <pp-col
        cols="12"
        class="text-center text-sm-right"
      >
        <pp-button
          type="primary"
          class="btn-return-checkin mx-3 my-4"
          text="Return to Check in"
          @click="checkIn"
        />

        <pp-button
          v-if="practiceInfo.site_name"
          class="mx-3 my-4"
          type="primary"
          :href="`https://${practiceInfo.site_name}`"
          text="Return to Home Page"
          target="_top"
          @click="returnHomeButtonClick"
        />
      </pp-col>
    </pp-row>
  </pp-container>
</template>

<script>
import Vuex from 'vuex'
const { mapGetters } = Vuex

export default {
  name: 'ViewsThankYou',
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      practiceInfo: 'practice/practiceInfo'
    }),
    callMissed () {
      return this.$route.params.missed
    },
    thankYouMessage () {
      return this.$route.params.missed ? `Unfortunately ${this.practiceInfo.name} is unavailable right now, please try again later.` : 'Thank you for your visit! If you have any questions or concerns, please do not hesitate to get in touch.'
    }
  },
  mounted () {
    this.$store.dispatch('visitSession/disconnect')
  },
  methods: {
    checkIn () {
      this.$ppAnalytics.trackEvent({
        action: 'return_to_check_in'
      })

      // redirect back to view checkin with the query params
      this.$router.push({ name: 'ViewsCheckIn' })
    },
    returnHomeButtonClick () {
      this.$ppAnalytics.trackEvent({
        action: 'return_to_home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/variables";

  $check-icon-size: 42px;

  p {
    font: 22px/32px $body-font-family;
  }

  .pp-icon-check {
    height: $check-icon-size;
    width: $check-icon-size;
  }

  .end-call-img {
    img {
      width: 100%;
      max-width: 444px;
      @media screen and (max-height: 600px) and (max-width: 479px) {
        display: none;
      }
    }
  }

  .btn-return-checkin {
    border: 1px solid #D9DBE6;
  }
</style>
